module.exports = __webpack_public_path__ + "static/media/img3.a83e37f4.svg";